module.exports = __webpack_public_path__ + "media/images/welcome_page_courses-4a80eafd4c61a1bb68cdece9204f755b.png";